import { Component, OnInit } from '@angular/core';
import { ConfirmState } from 'src/app/shared/dialogs/models/ConfirmState';
import { MsgOptions } from 'src/app/shared/dialogs/models/MsgOptions';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  options: MsgOptions;

  constructor(private state: ConfirmState) {
    this.options = state.options;
  }

  ngOnInit(): void {
  }

  yes() {
    this.state.modal.close('confirmed');
  }

  no() {
    this.state.modal.dismiss('not confirmed');
  }
}
